"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAGA_ERROR = void 0;
exports["default"] = sagaError;
var SAGA_ERROR = 'WEB_CHAT/SAGA_ERROR';
exports.SAGA_ERROR = SAGA_ERROR;

function sagaError() {
  return {
    type: SAGA_ERROR
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTQUdBX0VSUk9SIiwic2FnYUVycm9yIiwidHlwZSJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NhZ2FFcnJvci50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTQUdBX0VSUk9SID0gJ1dFQl9DSEFUL1NBR0FfRVJST1InO1xuXG50eXBlIFNhZ2FFcnJvckFjdGlvbiA9IHtcbiAgdHlwZTogdHlwZW9mIFNBR0FfRVJST1I7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzYWdhRXJyb3IoKTogU2FnYUVycm9yQWN0aW9uIHtcbiAgcmV0dXJuIHsgdHlwZTogU0FHQV9FUlJPUiB9O1xufVxuXG5leHBvcnQgeyBTQUdBX0VSUk9SIH07XG5cbmV4cG9ydCB0eXBlIHsgU2FnYUVycm9yQWN0aW9uIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxVQUFVLEdBQUcscUJBQW5COzs7QUFNZSxTQUFTQyxTQUFULEdBQXNDO0VBQ25ELE9BQU87SUFBRUMsSUFBSSxFQUFFRjtFQUFSLENBQVA7QUFDRCJ9